import React from 'react';

var DownloadArrowIcon = function DownloadArrowIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "14",
    viewBox: "0 0 11 14"
  }, React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.903 0h1.195v10.08l2.417-2.464.845.86L5.5 12.41 1.64 8.477l.845-.86 2.418 2.463zM0 14v-1.217h11V14z"
  }));
};

export default DownloadArrowIcon;